import CustomSubTab from "../../../common/components/tab/CustomSubTab";
import { useSearchParams } from "react-router-dom";
import { Column, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import DeviceStatusSubTabContent from "./DeviceStatusSubTabContent";
import SearchBar from "../../../common/components/input/SearchBar";
import { useState } from "react";
import DeviceDetailsSubTabContent from "./DeviceDetailsSubTabContent";
// import DeviceLayoutSubTabContent from "./DeviceLayoutSubTabContent";
import CustomSegmentedControl from "../../../common/components/button/CustomSegmentedControl";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import Translate from "../../../common/translate/Translate";
import CategoryFilterButton from "../../../common/components/filter_button/CategoryFilterButton";
import DeviceLayoutEditModal from "../modals/DeviceLayoutEditModal";

const deviceSubTabs = [
    { value: "Status", label: Translate("store.tabs.device.status") },
    { value: "Details", label: Translate("store.tabs.device.details") },
    // { value: "StoreLayout", label: Translate("store.tabs.device.storeLayout") },
];

const visualTypeValues = [
    { label: "2D", value: "2d" },
    { label: "3D", value: "3d" },
];

function DeviceTabContent({ shopCode }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeSubTab = searchParams.get("subTab") || "Status";

    const handleSetSubTab = (tabValue) => {
        setSearchParams({ tab: "Device", subTab: tabValue }, { replace: true });
    };
    const [deviceFilter, setDeviceFilter] = useState(["all"]);
    const [statusFilter, setStatusFilter] = useState(["all"]);
    const [selectedVisualType, setSelectedVisualType] = useState("2d");

    // modal
    const [openEditModal, setOpenEditModal] = useState(false);

    return (
        <Column padding={"14px 0"} alignItem={"flex-start"} width={"100%"}>
            <Row width={"100%"} justifyContent={"space-between"}>
                <CustomSubTab tabs={deviceSubTabs} activeTab={activeSubTab} onClick={handleSetSubTab} />
                {activeSubTab === "Details" && (
                    <Row>
                        <SearchBar inputWidth={"250px"} hasSearchSelector={false} />
                        <SizedBox width={"10px"} />
                        <CategoryFilterButton
                            currentValues={deviceFilter}
                            setValues={setDeviceFilter}
                            type={"device"}
                        />
                        <SizedBox width={"10px"} />
                        <CategoryFilterButton
                            currentValues={statusFilter}
                            setValues={setStatusFilter}
                            type={"deviceStatus"}
                        />
                    </Row>
                )}
                {activeSubTab === "StoreLayout" && (
                    <Row>
                        <CustomSegmentedControl
                            values={visualTypeValues}
                            currentValue={selectedVisualType}
                            setValue={setSelectedVisualType}
                        />
                        <SizedBox width={"10px"} />
                        <SecondaryButton icon={"edit"} text={"Edit Layout"} onClick={() => setOpenEditModal(true)} />
                    </Row>
                )}
            </Row>
            <SizedBox height={"17px"} />
            {activeSubTab === "Status" && <DeviceStatusSubTabContent shopCode={shopCode} />}
            {activeSubTab === "Details" && <DeviceDetailsSubTabContent shopCode={shopCode} />}
            {/*{activeSubTab === "StoreLayout" && <DeviceLayoutSubTabContent />}*/}
            {openEditModal && <DeviceLayoutEditModal isOpen={openEditModal} onClose={() => setOpenEditModal(false)} />}
        </Column>
    );
}

export default DeviceTabContent;
